import { render, staticRenderFns } from "./menu.component.vue?vue&type=template&id=17d2ca8f&scoped=true&"
import script from "./menu.component.vue?vue&type=script&lang=ts&"
export * from "./menu.component.vue?vue&type=script&lang=ts&"
import style0 from "./menu.component.vue?vue&type=style&index=0&id=17d2ca8f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d2ca8f",
  null
  
)

export default component.exports